import type { SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement>

export function TurboPickupCloseIcon({
  width = 20,
  height = 20,
  ...props
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M15 5L5 15M5 5l10 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
